import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import flowRackService from "../services/flowRackInventory-service";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

const FlowRackInventory = () => {
  useEffect(() => {
    getDefaults();
  }, []);
  const [quantity, setQuantity] = useState("");
  const [quantityList, setQuantityList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [user, setUser] = useState("");
  const [cards, setCards] = useState("");
  const [ndc, setNDC] = useState("");
  const [drug_name, setDrugname] = useState("");
  const [qrCode, setQrCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [machineName, setMachineName] = useState("");
  const [machineNameList, setMachineNameList] = useState([]);
  const [expectedCardQuantity, setExpectedCardQuantity] = useState("");
  const [prepackSessionId, setPrepackSessionId] = useState("");
  async function getDefaults() {
    try {
      setLoading(true);
      let resp = await flowRackService.getDefaults();
      setQuantityList(resp?.lookups);
      setUsersList(resp?.packageUsers);
      setMachineNameList(resp?.machineNames);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting  details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }
  function handleQRScan(value) {
    const parts = value.split("|");
    if (parts.length >= 6) {
      const upc = parts[0];             // UPC
      const sessionId = parts[2];       // SESSION_ID → prepack_session_id
      const blisterCount = parts[4];    // BLISTER_COUNT → Expected Card Quantity
      const pillsPerBlister = parts[5]; // PILLS_PER_BLISTER → Pills per Blister
      const machineType = parts[6];     // MACHINE_TYPE → Machine Names
      setNDC(upc);
      setPrepackSessionId(sessionId);
      setExpectedCardQuantity(blisterCount);
      setQuantity(pillsPerBlister);
      if (machineType) {
        setMachineName(machineType);
      }
      if (upc) {
        getDrugName(upc);
      }
    }
  }
  async function getDrugName(value) {
    try {
      setLoading(true);
      let resp = await flowRackService.getDrugName(value);
      setDrugname(resp.drugName);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting  details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }
  const onSubmit = async () => {
    try {
      if (!ndc?.length || cards?.length === 0 || Number(cards) < 1 || !quantity?.length || !user?.length || !machineName?.length) {
        setError(true);
        return;
      }
      let data = {};
      setLoading(true);
      data["upc"] = ndc;
      data["cards_packed"] = cards;
      data["card_quantity"] = quantity;
      data["expected_card_quantity"] = expectedCardQuantity !== "" ? Number(expectedCardQuantity) : 0;
      data["prepack_session_id"] = prepackSessionId !== "" ? prepackSessionId : 0;
      data["packed_by"] = user;
      data["machine_name"] = machineName;
      await flowRackService.postdata(data);
      setNDC("");
      setDrugname("");
      setCards("");
      setQuantity("");
      setExpectedCardQuantity("");
      setPrepackSessionId("");
      setUser("");
      setMachineName("");
      setQrCode("");
      setError(false);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const [error, setError] = useState(false);
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w-full">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">{"FLOW RACK INVENTORY"}</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Scan QR Code
              </label>
              <input
                id="qrCode"
                type="text"
                placeholder="Scan QR Code"
                value={qrCode}
                onChange={(e) => setQrCode(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleQRScan(e.target.value);
                  }
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              />
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Scan UPC
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              <input
                id="ndc"
                type="text"
                placeholder="UPC"
                value={ndc}
                onChange={(e) => setNDC(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getDrugName(e.target.value);
                  }
                }}
                className={` ${error && !ndc ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && !ndc && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify UPC
                </p>
              )}
            </li>
            {drug_name?.length > 0 && <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Drug name
              </label>
              <input
                id="drug_name"
                type="text"
                disabled={true}
                placeholder="Drug name"
                value={drug_name}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
            </li>}

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Pills per Blister
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="quantity"
                aria-label="Select Pills per Blister"
                onChange={(e) => setQuantity(e.target.value)}
                value={quantity}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="">Select Pills per Blister</option>
                {quantityList
                  ? quantityList.map((item, i) => {
                    return (
                      <option key={item?.id} value={item?.value}>
                        {item?.text}
                      </option>
                    );
                  })
                  : null}
              </select>

              {error && !quantity && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify quantity
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Expected Card Quantity
              </label>
              <input
                id="expectedCardQuantity"
                name="expectedCardQuantity"
                type="number"
                value={expectedCardQuantity}
                placeholder="Expected Card Quantity"
                onChange={(e) => setExpectedCardQuantity(e.target.value)}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              />
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Actual Card Quantity
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                id="cards"
                name="cards"
                type="number"
                value={cards}
                placeholder="Actual Card Quantity"
                onChange={(e) => setCards(e.target.value)}
                className={` ${error && cards === "" ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && cards === "" && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                  You must specify actual card quantity
                </p>
              )}
              {Number(cards) < 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                  Please enter a number greater than zero
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
               Packed By
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="packed_by"
                aria-label="Select user"
                onChange={(e) => setUser(e.target.value)}
                value={user}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="">Select</option>
                {usersList
                  ? usersList.map((item, i) => {
                    return (
                      <option key={item?.user_name} value={item?.user_name}>
                        {item?.first_name + ", " + item?.last_name}
                      </option>
                    );
                  })
                  : null}
              </select>

              {error && !user && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify user
                </p>
              )}
            </li>
           
           <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Machine Names
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="machineName"
                aria-label="Select machine name"
                onChange={(e) => setMachineName(e.target.value)}
                value={machineName}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="">Select Machine Name</option>
                {machineNameList
                  ? machineNameList.map((item, i) => {
                    return (
                      <option key={item?.id} value={item?.value}>
                        {item?.text}
                      </option>
                    );
                  })
                  : null}
              </select>

              {error && !machineName && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify machine name
                </p>
              )}
            </li>

            <li className="inline-block text-sm leading-8 w-full">
              <button
                className="rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                aria-label="Create"
                onClick={() => onSubmit()}
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(FlowRackInventory)
);
